import { SupportPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import HomeIcon from "@redotech/redo-icons/home-02.svg";
import HomeFilledIcon from "@redotech/redo-icons/home-02_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useCapability } from "@redotech/redo-merchant-app-common/use-capability";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const SupportDashboardItems = memo(function SupportDashboardItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const supportEnabled = useCapability("support");
  const canViewSupportAnalytics = useHasPermission(
    SupportPermissions.VIEW_ANALYTICS,
  );

  const dashboardRoute = routes.supportBaseUrl + "/home";
  const dashboardRouteMatch = useMatch(`${dashboardRoute}/*`);

  if (!supportEnabled || !canViewSupportAnalytics) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: dashboardRoute }}
      anyChildSelected={!!dashboardRouteMatch}
      FilledIcon={HomeFilledIcon}
      friendlyName={t("Dashboard", {
        context: "customer support navigation label",
      })}
      id="support-dashboard"
      UnfilledIcon={HomeIcon}
    />
  );
});
